import { useMemo } from 'react';
import useBodyClass from '_hooks/useBodyClass';

import FilterBar from './components/FilterBar';
import useFilterBar from './hooks/useFilterBar';
import usePurchaseData from './hooks/usePurchaseData';
import PurchaseCard from './components/PurchaseCard';
import resolvePurchaseCardState from './helper.js/resolvePurchaseCardState';
import { PURCHASE_STATUS } from './constant/constant';
import './style.scss';
import SearchBar from './components/SearchBar';

const getPriorityRank = (status, isDisable) => {
  if (isDisable || status === PURCHASE_STATUS.CANCEL || status === PURCHASE_STATUS.REFUND) return 3;
  if (status === PURCHASE_STATUS.UNPAID) return 1;
  return 2;
};

function ListMyPurchaseV2() {
  useBodyClass('my-purchase-page');
  const { myOrders, isLoading } = usePurchaseData();
  const {
    filteredOrders,
    activeTab,
    setActiveTab,
    searchTerm,
    setSearchTerm
  } = useFilterBar(myOrders);

  const purchaseOrders = useMemo(
    () => {
      const mapped = (filteredOrders || []).map((order) => {
        const { status, statusText, meta, isDisable } = resolvePurchaseCardState(order);

        return {
          id: order?.id || order?.ref,
          orderRef: order?.ref,
          status,
          statusText,
          isDisable,
          host: {
            photoUrl: order?.uPhotoUrl,
            name: order?.uName,
            group: order?.eGroupName,
            avatar: order?.uName?.charAt(0)?.toUpperCase() || '',
          },
          meta,
          title: order?.eTitle,
          itemsCount: order?.items?.length || 0,
          createdAt: order?.createdAt || 0,
        };
      });

      return mapped.sort((a, b) => {
        const rankA = getPriorityRank(a.status, a.isDisable);
        const rankB = getPriorityRank(b.status, b.isDisable);

        if (rankA !== rankB) {
          return rankA - rankB;
        }

        return (b.createdAt || 0) - (a.createdAt || 0);
      });
    },
    [filteredOrders]
  );

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className='list-my-purchase'>
      <FilterBar
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        ordersCount={filteredOrders.length}
      />
      <SearchBar
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {purchaseOrders.map((data, index) => (
          <PurchaseCard key={data.id || index} {...data}/>
        ))}
      </div>
    </div>
  )
}

export default ListMyPurchaseV2;
